import { goto } from '$app/navigation';
import { PUBLIC_BASE_URL } from '$env/static/public';
import { z } from 'zod';

export const loginSchemaStep1 = z.object({
	email: z
		.string()
		.email({ message: 'Bitte gebe eine gültige Email ein.' })
		.refine(
			async (email) => {
				if (!z.string().email().safeParse(email).success) {
					return true;
				}

				const response = await fetch(`${PUBLIC_BASE_URL}/login/check-email`, {
					method: 'POST',
					body: JSON.stringify(email),
					headers: {
						'Content-Type': 'application/json'
					}
				});

				if (!response.ok) {
					return false;
				}

				const data = await response.json();
				if (data.redirect) {
					return goto(data.redirect as string);
				}

				return data.valid as boolean;
			},
			{ message: 'Der Benutzer wurde nicht gefunden.' }
		),
	password: z.string().optional(),
	redirectTo: z.string().optional()
});

export const loginSchemaStep2 = loginSchemaStep1.extend({
	password: z.string().min(1, 'Bitte gebe ein Passwort ein.')
});
